import React, { useEffect, useState } from "react";
import { getTranscribeJobsByPatient } from "./patientApi";
import { StitchedTranscriptPanel, useSortedTranscriptionJobs } from "./TranscriptionDisplay";

const AudioTranscriptReview = ({ patientId }) => {
  const [transcription, setTranscription] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [loadError, setLoadError] = useState(null);
  const sortedJobs = useSortedTranscriptionJobs(transcription);

  useEffect(() => {
    if (!patientId) {
      setTranscription(null);
      setLoadError(null);
      return undefined;
    }

    let cancelled = false;
    setIsLoading(true);
    setLoadError(null);
    getTranscribeJobsByPatient(patientId).then((result) => {
      if (cancelled) return;
      setIsLoading(false);
      if (result?.error) {
        setTranscription(null);
        setLoadError(result.error);
      } else {
        setTranscription(result);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [patientId]);

  if (!patientId) {
    return (
      <p className="text-sm text-amber-700 bg-amber-50 border border-amber-200 rounded-md px-3 py-2">
        No patient ID available. Identify the patient first, then re-run the analysis.
      </p>
    );
  }

  if (isLoading) {
    return <p className="text-sm text-gray-500">Loading recordings…</p>;
  }

  if (loadError) {
    return (
      <p className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-md px-3 py-2">
        {loadError}
      </p>
    );
  }

  return (
    <div className="space-y-2">
      <p className="text-sm text-gray-700">
        Play each recording and follow the highlighted transcript. Confirm whether the audio
        contains a real conversation, or is silent, muted, or too unclear to transcribe.
      </p>
      <StitchedTranscriptPanel
        sortedJobs={sortedJobs}
        embedded
        bodyTextClass="text-sm leading-relaxed text-gray-800"
      />
    </div>
  );
};

export default AudioTranscriptReview;
